import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useWindowDimensions } from '../../utils/hooks/dimensions';
export var ResponsiveContainer = function (_a) {
    var condition = _a.condition, breakpoint = _a.breakpoint, component = _a.component, children = _a.children;
    var screenWidth = useWindowDimensions().width;
    var renderCondition = function () {
        switch (condition) {
            case 'gt':
                return screenWidth > breakpoint;
            case 'eq':
                return screenWidth === screenWidth;
            case 'lt':
                return screenWidth < breakpoint;
            default:
                return screenWidth < breakpoint;
        }
    };
    return _jsx(_Fragment, { children: renderCondition() ? component : children });
};
